const LICENSE_TYPES = {
  EMT: 9925005,
  PARAMEDIC: 9925007,
  PHYSICIAN: 9925027,
};

export default LICENSE_TYPES;
